var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpIocLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.623 8.19369L3.32638 12.614C3.29061 12.6499 3.25484 12.6858 3.21908 12.7218L1.60954 13.6921C0.608048 14.303 0 15.3811 0 16.5311V21.9936C0 23.5389 1.64531 24.4732 2.9687 23.7186L11.0879 19.0467C11.6602 18.7233 12.3756 18.7233 12.9478 19.0467L20.9955 23.7186C22.3189 24.5092 23.9642 23.5389 23.9642 21.9936V16.5311C23.9642 15.3811 23.3562 14.303 22.3905 13.6921L20.6021 12.614L13.5201 8.3015C12.5544 7.6187 11.5887 7.6187 10.623 8.19369Z",
    fill: "#3C9AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21.9936C24 23.1795 22.2832 22.8201 21.2459 22.2451L13.1982 17.5733C12.4829 17.1421 11.5887 17.1421 10.8376 17.5733L2.71833 22.2451C1.71684 22.8561 0 23.1795 0 21.9936C0 23.5389 1.64531 24.4732 2.9687 23.7186L11.0879 19.0467C11.6602 18.7233 12.3756 18.7233 12.9478 19.0467L20.9955 23.7186C22.3189 24.4732 24 23.5029 24 21.9936Z",
    fill: "white",
    fillOpacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.322175 8.87649C0.858687 9.73898 1.96748 10.1343 2.96897 9.73898C3.04051 9.70304 3.11204 9.70304 3.18358 9.6671C3.21934 9.63117 3.29088 9.63117 3.32665 9.59523L11.3028 4.74371C11.6962 4.52809 12.197 4.52809 12.5904 4.74371L20.6024 9.63117C21.6754 10.278 23.0345 9.84679 23.6068 8.91242C24.1791 7.90618 23.8214 6.64838 22.8557 6.07339L12.8408 0.215623C12.3401 -0.0718744 11.732 -0.0718744 11.2313 0.215623L1.10906 6.07339C0.10757 6.64838 -0.214338 7.87024 0.322175 8.87649Z",
    fill: "#3C9AE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9288 7.90619C23.9288 8.08588 23.8573 8.37337 23.7142 8.589C23.1777 9.45149 21.747 8.98431 20.9244 8.48119L12.9124 3.59373C12.3402 3.27029 11.6606 3.27029 11.0883 3.59373L3.00483 8.48119L2.9333 8.51712C2.86176 8.55306 2.826 8.55306 2.826 8.55306L2.79023 8.589C2.03911 8.87649 0.894551 9.52336 0.286504 8.589C0.179201 8.37337 0.107666 8.08588 0.107666 7.87025C0.107666 8.19369 0.179201 8.55306 0.358039 8.87649C0.894551 9.73899 2.00334 10.1702 3.00483 9.77492C3.07637 9.73899 3.1479 9.73899 3.21944 9.70305C3.25521 9.66711 3.32674 9.66711 3.36251 9.63118L11.3387 4.77965C11.7679 4.56403 12.2329 4.56403 12.6621 4.77965L20.674 9.66711C21.747 10.314 23.0704 9.88274 23.6785 8.91243C23.8215 8.55306 23.9288 8.22963 23.9288 7.90619Z",
    fill: "white",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpIocLogo);
export default __webpack_public_path__ + "static/media/sp_ioc_logo.0bf44985cb275b29c102c0458a81d93c.svg";
export { ForwardRef as ReactComponent };